import moment from 'moment-timezone';


moment.prototype.unixFull = function (val) {
  // if (val) {
  //   val = val + '';
  //   var unix = val.substr(0, 10);
  //   var milliseconds = val.substr(10, 3);
  //   this.unix(unix);
  //   this.milliseconds(milliseconds);
  //   console.error('赋值功能似乎有问题，先不启用');
  // }
  return this.unix() * 1000 + this.milliseconds();
}
moment.prototype.setAdayStart = function () {
  this.hour(0);
  this.minute(0);
  this.second(0);
  this.milliseconds(0);
  return this;
}
moment.prototype.setAdayEnd = function () {
  this.hour(23);
  this.minute(59);
  this.second(59);
  this.milliseconds(990);
  return this;
}
window.moment = moment;
var TIMEZONE = 'America/Los_Angeles';
var OFFSET = moment().utcOffset();
const ADAY = 1000 * 60 * 60 * 24;
Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份 
    "d+": this.getDate(), //日 
    "h+": this.getHours(), //小时 
    "m+": this.getMinutes(), //分 
    "s+": this.getSeconds(), //秒 
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
    "S": this.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}
Date.prototype.formatTimezone = function (fmt) {
  var timeZoneMoment = exportUtils.getOffsetMoment(this.getTime());
  var getFullYear = timeZoneMoment.year();
  var o = {
    "M+": timeZoneMoment.month() + 1, //月份
    "d+": timeZoneMoment.date(), //日
    "h+": timeZoneMoment.hour(), //小时 
    "m+": timeZoneMoment.minute(), //分 
    "s+": timeZoneMoment.second(), //秒 
    "q+": Math.floor((timeZoneMoment.month() + 3) / 3), //季度 
    "S": timeZoneMoment.millisecond() //毫秒 
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (getFullYear + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}

var interceptMethod = (oldClass, methodKey, newMethod) => {
  oldClass['_origin_' + methodKey] = oldClass[methodKey];
  oldClass[methodKey] = newMethod;
}

var exportUtils = {
  EXPIRES: 1000 * 60 * 60 * 24, //一天
  BASETIME: 1514764800000, //new Date('2018-01-01'),
  MAXTIME: 4070880000000, //new Date(4070880000000), // 2099-00-00
  getLastNumberDayStart(num) {
    let lastDay = new Date(Date.now() - ADAY * (num - 1));
    // lastDay.setHours(0);
    // lastDay.setMinutes(0);
    // lastDay.setSeconds(0);
    // lastDay.setMilliseconds(0);
    return lastDay;
  },
  getLastSevenDayStart() {
    return this.getLastNumberDayStart(7);
  },
  dateToMoment(date = new Date()) {
    return this.getOffsetMoment(date.getTime())
  },
  momentToDate(moment = this.getOffsetMoment()) {
    var date = new Date();
    date.setFullYear(moment.year());
    date.setMonth(moment.month());
    date.setDate(moment.date());
    date.setHours(moment.hour());
    date.setMinutes(moment.minute());
    date.setSeconds(moment.second());
    return date;
  },
  getDefaultRange() {
    var lastSevenMoment = this.dateToMoment(this.getLastSevenDayStart());
    lastSevenMoment.hour(0);
    lastSevenMoment.minute(0);
    lastSevenMoment.second(0);
    var lastSeven = this.momentToDate(lastSevenMoment);
    var now = this.momentToDate();
    console.log([lastSeven, now], lastSevenMoment.format())
    return [lastSeven, now]
  },
  dateFixRange(range = []) {
    let baseMinTime = this.BASETIME;
    let baseMaxTime = this.MAXTIME;
    let start = new Date(range[0] || baseMinTime).getTime();
    let end = new Date(range[1] || baseMaxTime).getTime();
    if (start < baseMinTime) {
      start = baseMinTime;
    }
    if (end > baseMaxTime) {
      end = baseMaxTime;
    }
    start = this.fixDayMin(new Date(start));
    end = this.fixDayMax(new Date(end));
    return [new Date(start), end];
  },
  dateFixRangeTimezoneStamp(range = []) { // [date[0], date[1]]
    let baseMinTime = this.BASETIME;
    let baseMaxTime = this.MAXTIME;
    let start = new Date(range[0] || baseMinTime);
    let end = new Date(range[1] || baseMaxTime);
    if (start.getTime() < baseMinTime) {
      start = new Date(baseMinTime);
    }
    if (end.getTime() > baseMaxTime) {
      end = new Date(baseMaxTime);
    }
    // console.log(start.format('yyyy-MM-dd'), this.fixDayMinTimezone(this.getOffsetMoment(start.format('yyyy-MM-dd'))));
    // console.log(end.format('yyyy-MM-dd'), this.fixDayMaxTimezone(this.getOffsetMoment(end.format('yyyy-MM-dd'))));
    start = this.fixDayMinTimezone(this.getOffsetMoment(start.format('yyyy-MM-dd')));
    end = this.fixDayMaxTimezone(this.getOffsetMoment(end.format('yyyy-MM-dd')));
    return [start.unixFull(), end.unixFull()];
  },
  fixDayMinTimezone(dataMoment) {
    dataMoment.hours(0);
    dataMoment.minutes(0);
    dataMoment.seconds(0);
    dataMoment.milliseconds(0);
    return dataMoment;
  },
  fixDayMaxTimezone(dataMoment) {
    dataMoment.hours(23);
    dataMoment.minutes(59);
    dataMoment.seconds(59);
    dataMoment.milliseconds(900);
    return dataMoment;
  },
  fixDayMin(date) { // 截取过去一天做大的时刻，如昨天的00:00:00  今天则为当前时刻最大
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date
  },
  fixDayMax(date) { // 截取过去一天做大的时刻，如昨天的23:59:59  今天则为当前时刻最大
    date.setHours(23);
    date.setMinutes(59);
    date.setSeconds(59);
    date.setMilliseconds(999);
    return date.getTime() < Date.now() ? date : new Date()
  },
  formatDateTimezone(timestamp) {
    var now = new Date().getTime();
    var timeNow = this.getOffsetMoment();
    var ahour = 3600 * 1000;
    var timeTodayStamp = timeNow.hour() * ahour + timeNow.minute() * 60 * 1000 + timeNow.second() * 1000 + timeNow.milliseconds()
    var aday = 24 * ahour;
    var ayear = 365 * aday;
    var minus = now - timestamp;
    if (minus >= ayear) {
      return this.getOffsetMoment(timestamp).format('YYYY-MM-DD HH:mm');
    }
    if (minus >= aday + timeTodayStamp) {
      return this.getOffsetMoment(timestamp).format('MM-DD HH:mm');
    }
    if (minus > timeTodayStamp) {
      return '昨天 ' + this.getOffsetMoment(timestamp).format('HH:mm');
    }
    if (minus >= ahour) {
      return '今天 ' + this.getOffsetMoment(timestamp).format('HH:mm');
    }
    var timeMinus = Math.abs(this.getOffsetMoment() - timestamp);
    timeMinus = Math.floor(timeMinus / 1000);
    return timeMinus <= 60 * 10 ? '刚刚' : Math.floor(timeMinus / 60) + '分钟前'
  },
  setTimezone(timeZone, offset) { // 东八区传8 西五区传-5 调用此方法会替换全局Date;
    TIMEZONE = timeZone;
    OFFSET = offset;
  },
  getDate(timestamp = Date.now()) { // 美西时间
    var date = new Date(timestamp);
    var timezone = -8;
    var localTimezone = date.getTimezoneOffset();
    date.setTime(timestamp + localTimezone * 60 * 1000 + timezone * 60 * 60 * 1000);
    return date;
  },
  getOffsetMoment(time = new Date().getTime()) {
    if (TIMEZONE) {
      return moment.tz(time, TIMEZONE)
    }
    return moment(time);
  },
  getTimeZone() {
    return TIMEZONE;
  },
  runMeixiTime() {
    return this.getOffsetMoment().format('YYYY-MM-DD HH:mm:ss')
  }
}
export default exportUtils;



// WEBPACK FOOTER //
// ./src/utils/dateUtils.js